import { addDays } from 'date-fns';

export const getNextDay = (date: Date) => {
  const newDate = new Date(date);
  return addDays(newDate, 1);
};
